import React, { useEffect } from 'react';
import { CssBaseline } from '../../components';
import { SecurePage, withLang } from '../../server/withUser';
import axios from 'axios';
import { ThemeProvider } from 'react-jss';
import { axiTheme } from '../../theme';
import AxiRegistration from '../../components/pages/AxiRegistration/AxiRegistration';
import Head from 'next/head';

const Index: SecurePage = () => {
  useEffect(() => {
    axios.post('/api/onboard/get-token').then(() => true);
  }, []);
  return (
    <ThemeProvider theme={axiTheme}>
      <Head>
        <title>Align X-Ray Insights</title>
        <link
          rel="icon"
          href="/axi_favicon.png"
          type="image/png"
          key="favicon"
        />
      </Head>
      <CssBaseline>
        <AxiRegistration />
      </CssBaseline>
    </ThemeProvider>
  );
};

export const getServerSideProps = withLang();
export default Index;
